import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Down Arrow And Circle Stroke
 */

export default function DownArrowAndCircleStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.64645 10.3536C7.84171 10.5488 8.15829 10.5488 8.35355 10.3536L11.3536 7.35355C11.5488 7.15829 11.5488 6.84171 11.3536 6.64645C11.1583 6.45118 10.8417 6.45118 10.6464 6.64645L8 9.29289L5.35355 6.64645Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
